export const SCOPE_ALL_CLIENTS = 'all';
export const SCOPE_SPECIFIC_CLIENTS = 'specific';
export const SCOPE_COMPANY_TYPES = 'company_type';
export const SCOPE_CONTACT_TYPES = 'contact_type';
export const SCOPE_PARENT_COMPANY = 'parent_company';
export const SCOPE_TOP_LEVEL = 'top_level';

export const automationMethodOptions = [
  { value: 'POST', label: 'POST' },
  { value: 'GET', label: 'GET' },
  { value: 'PUT', label: 'PUT' }
];
